import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Loader from '../components/loader.js';
import NavBarAttendant from '../components/nav/navbar-attendant.js';
import AuthCheck from '../components/auth-check.js';
import ReportsListEmpty from '../components/cleanings/reports-list-empty-state.js';
import CleaningsEmpty from '../components/cleanings/empty-all.js';
import { openCleaningReport } from '../actions/cleaning-actions.js';
import setTitle from '../decorators/set-title.js';
import { FILTER_CLEANINGS_PAST } from '../strings.js';

export class OfficeAttendantCleaningReportsRoute extends React.PureComponent {
  componentDidMount() {
    const prevCleaning = this.props.cleanings[0];
    if (prevCleaning) {
      this.props.actions.openCleaningReport(prevCleaning);
    }
  }

  componentDidUpdate(prevProps) {
    const prevPrevCleaning = prevProps.cleanings[0];
    const prevCleaning = this.props.cleanings[0];
    if (prevCleaning !== prevPrevCleaning) {
      this.props.actions.openCleaningReport(prevCleaning);
    }
  }

  render() {
    return (
      <div className="office-attendant-cleaning-reports">
        <AuthCheck permissions={{ can_manage_cleanings: true }} />
        <NavBarAttendant />
        <div className="variable-width-column">
          {this.props.isRequesting && <Loader />}
          {!this.props.cleanings.length && this.props.hasCleanings && (
            <div className="empty-reports fixed-width-column">
              <ReportsListEmpty />
            </div>
          )}
          {!this.props.isRequesting && !this.props.hasCleanings && (
            <CleaningsEmpty />
          )}
        </div>
      </div>
    );
  }
}

OfficeAttendantCleaningReportsRoute.propTypes = {
  cleanings: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
    })
  ).isRequired,
  hasCleanings: PropTypes.bool,
  isRequesting: PropTypes.bool,
};

OfficeAttendantCleaningReportsRoute = setTitle(() => {
  return 'Office Attendant Shift Reports';
})(OfficeAttendantCleaningReportsRoute);

export function mapStateToProps(state) {
  let pastCleanings = state.cleanings.items.filter(FILTER_CLEANINGS_PAST);
  pastCleanings.sort((a, b) => (a.start_datetime < b.start_datetime ? 1 : -1));
  return {
    cleanings: pastCleanings,
    hasCleanings: state.cleanings.items.length > 0,
    isRequesting: state.cleanings.isRequesting,
  };
}

export function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        openCleaningReport,
      },
      dispatch
    ),
  };
}

function areStatesEqual(prev, next) {
  return (
    prev.cleanings.items === next.cleanings.items &&
    prev.cleanings.isRequesting === next.cleanings.isRequesting
  );
}

export default connect(mapStateToProps, mapDispatchToProps, null, {
  areStatesEqual,
})(OfficeAttendantCleaningReportsRoute);
